import { memo, useContext } from 'react';
import { default as ReactGA4 } from 'react-ga4';
import { twMerge } from 'tailwind-merge';
import cn from 'classnames';
import { Element, RouterLink } from 'src/components';
import { SearchDropdownContext } from '.';

interface IProps {
    id: string;
    value: string;
    onClick: () => void;
    isTopic?: boolean;
    index: number;
}

const SearchItem = ({ id, value, onClick, isTopic, index }: IProps) => {
    const currFocus = useContext(SearchDropdownContext);
    const url = isTopic ? `/t${id}.epi` : `/c${id}.epi`;

    const handleClick = () => {
        if (onClick) {
            onClick();
        }

        ReactGA4.event({
            category: 'mobile_search',
            action: 'clickSuggestion',
        });
    };

    return (
        <Element
            key={id}
            renderAs="li"
            className={cn(
                'search-item',
                'border-b border-solid border-[#e9ecef]'
            )}
        >
            <RouterLink
                to={url}
                onClick={handleClick}
                className={twMerge(
                    'relative',
                    'block',
                    'w-full',
                    'px-[10px] py-[8px]',
                    cn({
                        ['bg-[#eee]']: currFocus === index,
                        ['pr-[60px]']: isTopic,
                    })
                )}
            >
                <Element dangerouslySetInnerHTML={{ __html: value }} />
                {isTopic && (
                    <Element
                        className={cn(
                            'absolute right-[10px] top-[15px]',
                            'text-[1.1rem] font-semibold text-[#ccc]'
                        )}
                    >
                        CHỦ ĐỀ
                    </Element>
                )}
            </RouterLink>
        </Element>
    );
};

export default memo(SearchItem);
